import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LancamentoFolhaListarComponent } from './lancamento-folha-listar.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: LancamentoFolhaListarComponent}
  ])],
  exports: [RouterModule]
})
export class LancamentoFolhaListarRoutingModule { }
